export default __webpack_public_path__ + "static/media/pencil.b415d786.png";